import { useEffect, useState } from "react";
import styles from "../../../ProductsDetails.module.css";
import { useTranslation } from "react-i18next";
import AnimatedDetailsText from "../../../AnimatedDetailsText";
// import ModelSlider from "../../../ModelSlider";

function DionWallRemote() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  const [imagesLoaded, setImagesLoaded] = useState({});

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleImageLoad = (index) => {
    setImagesLoaded((prevState) => ({
      ...prevState,
      [index]: true,
    }));
  };
  const { t } = useTranslation();
  const imageData = [
    {
      img: isSmallScreen ? "01.jpg" : "01.jpg",
      title: "",
      subtitle: t(`beeDionWallRemoteSwitch.subtitle1`),

      top: isSmallScreen ? "75%" : "40%",
      left: isSmallScreen ? "50%" : "50%",
      textAlign: isSmallScreen ? "center" : "right",
      width: isSmallScreen ? "60%" : "45%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "02.jpg" : "02.jpg",
      title: "",
      subtitle: t(`beeDionWallRemoteSwitch.subtitle2`),

      top: isSmallScreen ? "15%" : "50%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "03.jpg" : "03.jpg",
      title: t(`beeDionWallRemoteSwitch.title3`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle3`),

      top: isSmallScreen ? "80%" : "50%",
      left: isSmallScreen ? "50%" : "77%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      img: isSmallScreen ? "04.jpg" : "04.jpg",
      title: t(`beeDionWallRemoteSwitch.title4`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle4`),
      top: isSmallScreen ? "12%" : "50%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#fff",
    },
    {
      img: isSmallScreen ? "05.jpg" : "05.jpg",
      title: "",
      subtitle: t(`beeDionWallRemoteSwitch.subtitle5`),
      top: isSmallScreen ? "85%" : "50%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "60%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "06.jpg" : "06.jpg",
      title: t(`beeDionWallRemoteSwitch.title6`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle6`),

      top: isSmallScreen ? "80%" : "50%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "25%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "07.jpg" : "07.jpg",
      title: t(`beeDionWallRemoteSwitch.title7`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle7`),

      top: isSmallScreen ? "20%" : "40%",
      left: isSmallScreen ? "50%" : "75%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "60%" : "35%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "08.jpg" : "08.jpg",
      title: t(`beeDionWallRemoteSwitch.title8`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle8`),

      top: isSmallScreen ? "80%" : "60%",
      left: isSmallScreen ? "50%" : "20%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "20%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "09.jpg" : "09.jpg",
      title: t(`beeDionWallRemoteSwitch.title9`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle9`),

      top: isSmallScreen ? "59%" : "50%",
      left: isSmallScreen ? "50%" : "78%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "10.jpg" : "10.jpg",
      title: t(`beeDionWallRemoteSwitch.title10`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle10`),

      top: isSmallScreen ? "75%" : "50%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
    {
      img: isSmallScreen ? "11.jpg" : "11.jpg",
      title: t(`beeDionWallRemoteSwitch.title11`),
      subtitle: t(`beeDionWallRemoteSwitch.subtitle11`),

      top: isSmallScreen ? "25%" : "50%",
      left: isSmallScreen ? "50%" : "70%",
      textAlign: isSmallScreen ? "center" : "center",
      width: isSmallScreen ? "70%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#fff" : "#fff",
    },
    {
      img: isSmallScreen ? "12.jpg" : "12.jpg",
      title: "",
      subtitle: t(`beeDionWallRemoteSwitch.subtitle12`),

      top: isSmallScreen ? "80%" : "50%",
      left: isSmallScreen ? "50%" : "30%",
      textAlign: isSmallScreen ? "center" : "left",
      width: isSmallScreen ? "70%" : "30%",
      direction: isSmallScreen ? "up" : "down",
      zoom: true,
      color: isSmallScreen ? "#000" : "#000",
    },
  ];

  const basePath = `${process.env.PUBLIC_URL}/images/03-tis-bee/wall-switch/details/dion-wall-remote`;
  const smallScreenPath = `${basePath}/smallScreens`;

  // const modelsData = [
  //   {
  //     id: 1,
  //     name: "TIS-IP-INT-OUT-DB10",
  //     image: `${basePath}/models/01.png`,
  //   },
  // ];

  return (
    <div className={styles.container}>
      {imageData.map((item, index) => (
        <div
          key={index}
          className={styles.imgContainer}
          style={{ position: "relative", width: "100vw", display: "block" }}
        >
          {item.isVideo ? (
            <VideoAsGif
              className={styles.videoContainer}
              style={{ width: "100vw" }}
              videoSrc={`${basePath}/${item.img}`}
            />
          ) : (
            <img
              style={{
                width: "100vw",
                marginRight: isSmallScreen ? "0" : "0",
                paddingLeft: isSmallScreen ? "0" : "0",
              }}
              src={
                isSmallScreen
                  ? `${smallScreenPath}/${item.img}`
                  : `${basePath}/${item.img}`
              }
              alt=""
              onLoad={() => handleImageLoad(index)}
            />
          )}
          {imagesLoaded[index] && (
            <div
              style={{
                position: "absolute",
                top: item.top,
                left: item.left,
                transform: "translate(-50%, -50%)",
                textAlign: item.textAlign,
                width: item.width,
              }}
            >
              <AnimatedDetailsText
                text={{
                  title: item.title,
                  subtitle: item.subtitle,
                }}
                color={item.color || "#000"}
                textAlign={item.textAlign}
                margin="20px 0"
                padding="10px"
                direction={item.direction}
                fontSize={item.fontSize || "20px"}
                zoom={item.zoom}
              />
            </div>
          )}
          {/* عرض مكون ModelSlider بعد الصورة الأولى فقط */}

          {/* {index === 0 && (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ textAlign: "center", fontSize: "20px",marginTop: "40px" }}>Product Models</h1>
              <div>
                <ModelSlider models={modelsData} />
              </div>
            </div>
          )} */}
        </div>
      ))}
    </div>
  );
}

export default DionWallRemote;

const VideoAsGif = ({ videoSrc, className }) => {
  return (
    <div className={styles.videoContainer}>
      <video
        className={styles.fullscreenVideo}
        autoPlay
        muted
        loop
        playsInline // مهم لأجهزة iPhone
        disablePictureInPicture // منع خاصية "صورة داخل صورة"
        controls={false} // إخفاء أزرار التحكم
        style={{ display: "block", width: "100%" }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};
